import { useQuery } from "@tanstack/react-query"
import { API_BASE_URL } from "../../constants"

/**
 * @param {number} trainingId
 * @returns {{data: import("../type").Training}}
 */
export const useTrainingDetailsQuery = (trainingId) => {
    return useQuery({
        queryKey: ['useTrainingDetailsQuery', trainingId],
        queryFn: async () => {
            const result = await fetch(`${API_BASE_URL}/courses/${trainingId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("token")}`,
                }
            }).then(res => res.json())

            return result.data
        },
        enabled: Boolean(trainingId),
        retry: 2,
        // stale for about hour
        staleTime: 1000 * 60 * 58
    })
}